<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal">
      <div class="title-close">
        <h1 class="modal-title">Edit Event's max capacity</h1>
        <span class="material-icons" @click="$emit('close')"> close </span>
      </div>
      <div class="description">
        Setting the event's capacity determines the maximum number of tickets created. This limit
        might be removed later.
      </div>
      <div class="input-container">
        <v-switch
          v-model="enabled"
          :label="enabled ? 'Enabled' : 'Disabled'"
          class="toggle-container"
        />
        <text-field
          v-model.trim="maxCapacityValue"
          :validator="$v.maxCapacityValue"
          :error-messages="{
            numeric: 'Value must be positive number.',
            minValue: 'Value must be higher than 0.',
          }"
          label="Event's max capacity"
          :disabled="!enabled"
        />
      </div>
      <div class="button-container">
        <main-button style="max-width: 3rem" @click.stop="onSave"> SAVE </main-button>
      </div>
    </div>
  </div>
</template>

<script>
import { minValue, numeric, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'event-max-capacity-modal',
  props: {
    audienceCapacity: Number,
  },
  data() {
    return {
      enabled: !!this.audienceCapacity || this.audienceCapacity === 0,
      maxCapacityValue: this.audienceCapacity,
    }
  },
  validations() {
    return {
      maxCapacityValue: {
        required: requiredIf(() => this.enabled),
        numeric,
        minValue: minValue(1),
      },
    }
  },
  watch: {
    enabled(val) {
      if (!val) {
        this.maxCapacityValue = null
      }
    },
  },
  methods: {
    onSave() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.$emit('updateMaxCapacity', this.maxCapacityValue)
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 32rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-title {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
.title-close {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.material-icons {
  cursor: pointer;
}
.description {
  margin-top: 0.75rem;
  color: #979797;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.input-container {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  align-self: stretch;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
}
.toggle-container {
  max-width: 7.15rem;
  margin-bottom: 12px;
}
</style>
